<template>
    <div>
      <div class="experienceItem">
        <div class="itemBox"> 
          <div class="itemImg">
            <div style="width: 80px; height: 80px; margin-right: 15px;" :id="id" :ref="id"></div>
          </div>
          <div class="itemImgRight">
            <div class="itemAccounts">下载备考通学生端APP</div>  
            <div class="itemAccounts">学员注册邀请码：{{ code }}</div>
            <div class="btn btn2" @click="imgBtn()">保存图片</div>
          </div>
        </div> 
      </div>
 
      <div class="experienceItem2">
        <div class="itemBox" :id="pictureId" :ref="pictureId">
          <div class="itemTitle">识别二维码下载APP</div>
          <div class="itemImg">
            <div style="width: 200; height: 200" :id="experienceId" :ref="experienceId"></div>
          </div>
          <div class="itemAccounts">学员注册邀请码：{{ code }}</div> 
        </div> 
      </div>
    </div>
  </template>
  <script>
  import QRCode from "qrcodejs2";
  import html2canvas from "html2canvas";
  export default {
    data() {
      return {
        qrcode: "",
        qrcode2: "",
        groupName: "",
      };
    },
    props: {
      id: {
        type: String,
        required: true,
      }, 
      codeUrl: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "80",
      },
      height: {
        type: String,
        default: "80",
      },
      colorDark: {
        type: String,
        default: "#000000",
      },
      colorLight: {
        type: String,
        default: "#ffffff",
      },
      title: {
        type: String,
        default: "",
      },
      username: {
        type: String,
        default: "",
      },
      password: {
        type: String,
        default: "",
      }, 
      pictureId: {
        type: String,
        required: true,
      },
      code: {
        type: String,
        default: "",
      }, 
      experienceId: {
        type: String,
        required: true,
      }, 
    },
    watch: {
      codeUrl(newText) {
        this.experienceQrcode();
        this.createQrcode();
      },
    },
    created() {
      let _name = this.$store.state.user.userInfo.group.name;
      this.groupName = _name;
    },
    mounted() {
      this.experienceQrcode();
      this.createQrcode();
      // this.createNewQrcode();
    },
    methods: {
      createPoster() {
        // 生成海报
        let dom = this.$refs[this.pictureId];
        html2canvas(dom, {
          width: dom.clientWidth, // 生成图片的宽度
          height: dom.clientHeight, // 生成图片的高度
          scale: 2, //scale 将其调大可以解决低分辨率设备下生成的图片模糊问题
          useCORS: true, // 是否允许跨域 如果不行在img标签增加 crossOrigin="Anonymous" 属性
        }).then((canvas) => {
          // 生成一个base64的图片路径
          let dataURL = canvas.toDataURL("image/png");
          let myName = this.title + ".jpg";
          console.log(dataURL);
          this.downloadFile(dataURL, myName);
        });
      },
  
      // ewmBtn() {
      //   // 保存二维码
      //   this.download();
      // },
      imgBtn() {
        // 保存图片
        this.createPoster();
      },
  
      // dataURLtoBlob(dataurl) {
      //   const arr = dataurl.split(",");
      //   const mime = arr[0].match(/:(.*?);/)[1];
      //   const bstr = atob(arr[1]);
      //   let n = bstr.length;
      //   const u8arr = new Uint8Array(n);
      //   while (n--) {
      //     u8arr[n] = bstr.charCodeAt(n);
      //   }
      //   return new Blob([u8arr], { type: mime });
      // },
      downloadFile(url, name) {
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", name);
        a.setAttribute("target", "_blank");
        const clickEvent = document.createEvent("MouseEvents");
        clickEvent.initEvent("click", true, true);
        a.dispatchEvent(clickEvent);
      },
      //下载到本地
      // download(record) {
      //   html2canvas(this.$refs[this.id], {
      //     scale: 5,
      //   }).then((canvas) => {
      //     const base64 = canvas.toDataURL("image/png");
      //     const myBlob = this.dataURLtoBlob(base64);
      //     const myUrl = URL.createObjectURL(myBlob);
      //     console.log("myUrl---", myUrl);
      //     const myName = this.title + ".jpg";
      //     this.downloadFile(myUrl, myName);
      //   });
      // },
      experienceQrcode() { 
        if (this.qrcode2) {
          this.$refs[this.experienceId].innerHTML = "";
        }
        this.qrcode2 = new QRCode(this.$refs[this.experienceId], {
          text: this.codeUrl,
          width: 200,
          height: 200,
          colorDark: this.colorDark,
          colorLight: this.colorLight,
          correctLevel: QRCode.CorrectLevel.H,
        }); 
      },
      // 有新的二维码地址了，先把之前的清除掉
      createQrcode() {
        if (this.qrcode) {
          this.$refs[this.id].innerHTML = "";
        }
        this.qrcode = new QRCode(this.$refs[this.id], {
          text: this.codeUrl,
          width: this.width,
          height: this.height,
          colorDark: this.colorDark,
          colorLight: this.colorLight,
          correctLevel: QRCode.CorrectLevel.H,
        }); 
      },
      // createNewQrcode() {
      //   if (this.qrcode) {
      //     this.$refs[this.newId].innerHTML = "";
      //   }
      //   this.qrcode = new QRCode(this.$refs[this.newId], {
      //     text: this.codeUrl,
      //     width: this.width,
      //     height: this.height,
      //     colorDark: this.colorDark,
      //     colorLight: this.colorLight,
      //     correctLevel: QRCode.CorrectLevel.H,
      //   });
      // },
    },
  };
  </script>
  <style lang="less" scoped>
  .experienceItem {
    .itemBox{
      display: flex;
      align-items: center;    
      margin-right: 10px;
      .itemImgRight{
        .itemAccounts{
          margin-bottom: 5px;
          font-size: 15px;
        }
        .btn{
          border: 1px solid #ddd;
          line-height: 30px;
          cursor: pointer;
          text-align: center;
          width: 100px;
          display: block;
          margin: 0 auto;
          margin-bottom: 10px;
        }
      }
    }

    // text-align: center;
    // margin-right: 20px;
    // border: 1px solid #dcdfe6;
    // .itemBox {
    //   padding: 20px;
    //   .itemTitle {
    //     margin-bottom: 10px;
    //   }
    //   .itemImg {
    //     margin-bottom: 10px;
    //   }
    //   .itemAccounts {
    //     margin-bottom: 10px;
    //   }
    //   .itemPassword {
    //   }
  
    //   .itemTitle3 {
    //     padding: 10px 0;
    //     font-size: 15px;
    //     font-weight: bold;
    //   }
    // }
    // .itemBtn {
    //   padding: 0px 20px 20px 20px;
    //   .btn {
    //     border: 1px solid #ddd;
    //     line-height: 30px;
    //     margin-bottom: 10px;
    //     cursor: pointer;
    //   }
    // }
  }

  .experienceItem2 {
    text-align: center;
    margin-right: 20px;
    border: 1px solid #dcdfe6;
    background: #FFF;
    position: fixed;
    left: 0;
    top: -500px;
    z-index: 100;
    .itemBox {
      padding: 20px;
      .itemTitle {
        margin-bottom: 10px;
      }
      .itemImg {
        margin-bottom: 10px;
      }
      .itemAccounts {
        margin-bottom: 10px;
      }
      .itemPassword {
      }
  
      .itemTitle3 {
        padding: 10px 0;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .itemBtn {
      padding: 0px 20px 20px 20px;
      .btn {
        border: 1px solid #ddd;
        line-height: 30px;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
  }
  .my-canvas {
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: red;
  }
  .downloadBox {
    position: fixed;
    left: -100%;
    bottom: 0;
  }
  </style>
  